export function secondsToHours(time) {
    let pad = function (num, size) { return ('000' + num).slice(size * -1); };
    let hours = Math.floor(time / 60 / 60);
    let minutes = Math.floor(time / 60) % 60;
    let seconds = Math.floor(time - minutes * 60);
    
    return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2);
}

export function secondsToDays(time) {
    let pad = function (num, size) { return ('000' + num).slice(size * -1); };    
    var days = Math.floor(time / (3600 * 24));
    var hours = Math.floor(time % (3600 * 24) / 3600);
    var minutes = Math.floor(time % 3600 / 60);
    var seconds = Math.floor(time % 60);

    return (days !== 0 ? pad(days, 2) + 'd, ' : '') + pad(hours, 2) + 'h, ' + pad(minutes, 2) + 'm, ' + pad(seconds, 2) + 's';
}